<div class="flex min-h-screen surface-ground">
	<div class="layout-main w-full">
		<div class="layout-content flex justify-content-center surface-ground">
			<div class="grid max-w-full text-900" [ngClass]="minHeightScreen()">
				<div class="col-12 flex align-items-end justify-content-center">
					<!-- <img [src]="getMenuTheme() === 'dim' ? './assets/images/logos/CAME-A_alpha_white_blue.png' : './assets/images/logos/CAME-A_alpha_white.png'" alt="Login Logo" class="my-5 w-14rem"> -->
					<img
						[src]="getMenuTheme() === 'dim' ? './assets/images/logos/cameconnect-main.png' : './assets/images/logos/cameconnect-whiteblack.png'"
						alt="Came Connect logo" class="my-5 w-22rem">
				</div>
				<div class="col-12 flex align-items-center justify-content-center">
					<div class="card surface-800 border-round flex align-items-center justify-content-center p-0">
						<div class="grid col-12 flex align-items-center p-0">
							<div class="col-12 py-5 px-5">
								<div class="text-center text-0 text-xl font-bold lg:mb-5">
									{{ 'UPDATE_PASSWORD' | translate }}
								</div>
								<form (ngSubmit)="submit()" [formGroup]="updatePasswordForm" class="grid mt-3">
									<div class="col-12">
										<div class="flex justify-content-between flex-wrap"
											[ngClass]="newShowErrorsCustomColor(this.f.password, 'borderRow', 'border-bluegray-900')">
											<div class="noSelectLabel-pswUpd flex align-items-center justify-content-center text-0"
												[ngClass]="newShowErrorsCustomColor(this.f.password, 'label', 'border-bluegray-900')">
												{{ 'INSERT_NEW_PASSWORD' | translate }}</div>
											<div class="flex align-items-center justify-content-center"
												[ngClass]="newShowErrorsCustomColor(this.f.password, 'borderInput', 'border-bluegray-900')">
												<p-password formControlName="password" id="registration-input-password"
													[toggleMask]="true" maxLength="64" [ngClass]="dynamicInputTextWidth()"
													styleClass="{{ dynamicInputTextWidth() }}"
													inputStyleClass="{{ dynamicInputTextWidth() }} pl-2_5rem border-1 border-bluegray-900">
												</p-password>
											</div>
										</div>
										<small *ngIf="showErrorRequiredMessage(this.f.password)" class="flex text-50 pt-1"
											[ngClass]="justifyMessagesNewValidator()">{{ 'PASSWORD_PATTERN_ERROR_NEW' | translate
											}}</small>
									</div>
									<div class="col-12">
										<div class="flex justify-content-between flex-wrap"
											[ngClass]="showErrorsConfirmFieldsCustomColor(this.f.passwordConfirm, 'borderRow', 'notEquivalentPassword', 'border-bluegray-900')">
											<div class="noSelectLabel-pswUpd flex align-items-center justify-content-center text-0"
												[ngClass]="showErrorsConfirmFieldsCustomColor(this.f.passwordConfirm, 'label', 'notEquivalentPassword', 'border-bluegray-900')">
												{{ 'CONFIRM_NEW_PASSWORD' | translate }}</div>
											<div class="flex align-items-center justify-content-center"
												[ngClass]="showErrorsConfirmFieldsCustomColor(this.f.passwordConfirm, 'borderInput', 'notEquivalentPassword', 'border-bluegray-900')">
												<p-password formControlName="passwordConfirm"
													id="registration-input-passwordConfirm" [toggleMask]="true" maxLength="64"
													[ngClass]="dynamicInputTextWidth()" styleClass="{{ dynamicInputTextWidth() }}"
													inputStyleClass="{{ dynamicInputTextWidth() }} pl-2_5rem  border-1 border-bluegray-900">
												</p-password>
											</div>
										</div>
										<small
											*ngIf="showErrorConfirmInvalidMessage(this.f.passwordConfirm,'notEquivalentPassword')"
											class="flex align-items-center text-50 pt-1"
											[ngClass]="justifyMessagesNewValidator()">{{ 'PASSWORDS_NOT_MATCH' | translate
											}}</small>
									</div>
									<div class="col-12">
										<button pButton pRipple type="submit" label="{{ 'UPDATE_PASSWORD' | translate }}"
											class="p-button-primary text-normal font-semibold w-full">
										</button>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
				<div class="col-12 flex align-items-start justify-content-center">
					<!-- <img [src]="getMenuTheme() === 'dim' ? './assets/images/logos/cameconnect-main.png' : './assets/images/logos/cameconnect-whiteblack.png'" alt="Came Connect logo" class="my-5 w-22rem"> -->
				</div>
				<div [ngClass]="onLargeDesktop()">
					<label class="h-10rem"></label>
				</div>
			</div>
		</div>

		<app-password-update-footer [ngClass]="fixedFooter()"></app-password-update-footer>
	</div>
</div>